module.exports = __webpack_public_path__ + "img/xiangmu_05.57a85f55.jpg";